import { render, staticRenderFns } from "./publishRFCCloseNumStatus.vue?vue&type=template&id=28344a00&scoped=true&"
import script from "./publishRFCCloseNumStatus.vue?vue&type=script&lang=js&"
export * from "./publishRFCCloseNumStatus.vue?vue&type=script&lang=js&"
import style0 from "./publishRFCCloseNumStatus.vue?vue&type=style&index=0&id=28344a00&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28344a00",
  null
  
)

export default component.exports